import React from 'react';
import { useFooterCTAs } from '../../../hooks';
import {
	FOOTER_CTA_TYPES,
	COMPARE_BUTTON_VARIANTS
} from '../../../global-constants';
import MyCars from './MyCars';
import CompareButton from '../CompareButton';
import DetailsButton from './DetailsButton';
import vehiclePropType from '../../../propTypes/vehiclePropType';

const Footer = ({ vehicle }) => {
	const { uuid, link } = vehicle;
	const { isCTARemoved, shouldRemoveBothMyCarsCTAs, footerHasCompare } =
		useFooterCTAs();

	return (
		<>
			{footerHasCompare && (
				<CompareButton
					uuid={uuid}
					title={vehicle.title}
					variant={COMPARE_BUTTON_VARIANTS.FOOTER}
				/>
			)}
			<MyCars
				vehicle={vehicle}
				shouldRemoveBothMyCarsCTAs={shouldRemoveBothMyCarsCTAs}
			/>
			{!isCTARemoved(FOOTER_CTA_TYPES.DETAILS) && (
				<DetailsButton uuid={uuid} link={link} title={vehicle.title} />
			)}
		</>
	);
};

Footer.propTypes = {
	vehicle: vehiclePropType.isRequired
};

export default Footer;
